import * as marietta from '../..';

class BoundInfoCollection {
    minPoint: marietta.core.Point;

    maxPoint: marietta.core.Point;

    width: number;

    height: number;

    center: marietta.core.Point;
}
export default BoundInfoCollection;
